import styled from 'styled-components';
import { Navbar } from 'react-bootstrap';
import '@fontsource/open-sans';
import { Link } from 'react-router-dom';

export const MainNavbar = styled(Navbar)`
  background: #0747a6;
  z-index: 1000;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

  font-family: 'Open Sans', sans-serif;

  .navbar-brand {
    padding: 0;

    .crm-navbar-logo {
      display: block;
      width: 100px;
      height: 30px;
    }
  }

  .dropdown-header {
    padding-top: 0;
    padding-bottom: 0;
    font-size: 0.775rem;
  }

  .navbar-collapse {
    max-height: 80vh;
    overflow-y: auto;
    @media (min-width: 992px) {
      max-height: initial;
      overflow-y: initial;
    }
  }

  &.navbar-dark .navbar-nav .nav-link {
    color: #ffffffff;
  }

  .dropdown-item,
  .nav-link {
    display: flex;
    font-size: 0.9rem;
    align-items: center;

    @media (min-width: 1440px) {
      font-size: 1rem;
    }

    img,
    svg {
      height: 20px;
      margin-right: 0px;
    }
  }

  .item-dpto {
    background: #fff !important;
    position: relative;
  }

  .item-dpto button {
    color: #000 !important;
    background: #fff;
    border-width: 1px;
    border-style: ridge;
    border-color: #cecece;
  }

  .item-dpto:hover {
    background: #cecece !important;
    color: #1caf9a !important;
  }

  .posicao {
    position: absolute;
    top: 25px;
    right: 2px;
    border-radius: 50%;
    background: #0747a6;
    color: white;
    width: 23px;
    text-align: center;
  }

  .notificar {
    display: flex;
    opacity: 1;
    animation: chamarDptoLancamento 1s linear infinite;
  }

  @keyframes chamarDptoLancamento {
    0% {
      background: #adb5bd;
      color: #000;
    }

    50% {
      background: #ffc700;
      color: #000;
    }
  }

  // nova versão

  //Remover Seta Padrão do <NavDropdown />
  .crm-dropdown .dropdown-toggle::after {
    display: none !important;
  }

  .crm-dropdown-caret {
    transition: transform 0.3s ease;
    color: rgba(255, 255, 255, 0.9);
  }
  .crm-dropdown.show .crm-dropdown-caret {
    transform: rotate(180deg);
    color: #58d0ff;
  }

  .crm-dropdown-span {
    color: rgba(255, 255, 255, 0.9);
  }
  .crm-dropdown.show .crm-dropdown-span {
    color: #58d0ff;
  }

  //CRM-DROPDOWN
  .crm-dropdown-item {
    background-color: transparent !important;
    padding: 0.3rem 0.5rem;
    display: flex;
    align-items: center;
    width: 100%;
  }

  .crm-dropdown-label {
    display: block;
    width: 100%;
    padding: 0.4rem 0.8rem;
    border-radius: 6px;
    background-color: transparent;
    transition: all 0.2s ease;
    font-weight: 500;
  }

  .crm-dropdown-item:hover .crm-dropdown-label {
    background-color: #58d0ff;
    color: white;
  }

  .crm-dropdown-item-no-hover:hover .crm-dropdown-label {
    background-color: none !important;
    color: none !important;
    pointer-events: none;
  }

  .navbar-separator {
    width: 1px;
    background-color: rgba(255, 255, 255, 0.5);
    margin-top: 5px;
    height: 30px;
    padding: 0 0;
    margin-right: 10px;
    margin-left: 10px;
  }

  .search-bar {
    display: inline-flex;
    align-items: center;
    position: relative;
    cursor: pointer;
    margin-right: 15px;
  }

  .search-bar input {
    position: absolute;
    top: 100%;
    right: 0;
    left: auto;
    width: 180px;
    padding: 0.5rem;
    border: none;
    border-radius: 4px;
    background-color: #f1f1f1;
    display: none;
    margin-top: 10px;
    opacity: 0;
    transition: all 0.3s ease;
    z-index: 10;
  }

  .search-bar input.show {
    display: block;
    opacity: 1;
    transform: translateX(0);
  }

  .search-bar button {
    background-color: transparent;
    border: none;
    color: #fff;
    font-size: 18px;
    position: relative;
    z-index: 20;
  }

  //foto de perfil e search

  .profile-container {
    display: inline-flex;
    align-items: center;
  }

  .profile-circle {
    width: 35px;
    height: 35px;
    border-radius: 50%;
    overflow: hidden;
    border: 2px solid #fff;
  }

  .profile-circle img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .profile-container span {
    color: white;
    // margin-left: 10px;
  }

  .btn-chat-navbar {
    position: relative;
    background: rgba(255, 255, 255, 0.15);
    border: 1px solid rgba(255, 255, 255, 0.35);
    color: #fff;
    cursor: pointer;
    padding: 6px 14px;
    border-radius: 20px;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    font-size: 0.85rem;
    font-weight: 600;
    gap: 6px;

    &:hover {
      background: rgba(255, 255, 255, 0.25);
      border-color: rgba(255, 255, 255, 0.5);
    }

    .chat-badge {
      position: absolute;
      top: 0;
      right: 0;
      background: #e74c3c;
      color: #fff;
      font-size: 0.65rem;
      font-weight: 700;
      min-width: 16px;
      height: 16px;
      line-height: 16px;
      text-align: center;
      border-radius: 8px;
      padding: 0 4px;
    }
  }

  .crm-dropdown-profile .nav-link {
    padding: 0 !important; /* Remove o padding para esse dropdown específico */
  }
  .dropdown-menu {
    max-height: calc(100vh - 80px);
    overflow-y: auto;
  }

  @media (min-width: 992px) {
    &.navbar {
      flex-wrap: nowrap;
      padding: 0.52rem 0.75rem;
    }

    .navbar-brand {
      flex: 0 0 auto;
      margin-right: 0.5rem;
    }

    .navbar-brand .crm-navbar-logo {
      width: 100px;
      height: 32px;
    }

    .crm-navbar-collapse {
      display: flex !important;
      flex-basis: auto;
      min-width: 0;
    }

    .crm-navbar-primary {
      align-items: center;
      flex: 1 1 auto;
      flex-wrap: nowrap;
      min-width: 0;
    }

    .crm-navbar-primary .dropdown-toggle,
    .crm-navbar-primary > .nav-link,
    .crm-navbar-primary .nav-item > .nav-link {
      align-items: center;
      min-width: 0;
      padding-left: 0.26rem;
      padding-right: 0.26rem;
      white-space: nowrap;
    }

    .crm-navbar-primary .mr-2 {
      margin-right: 0.25rem !important;
    }

    .crm-navbar-primary .ml-1 {
      margin-left: 0.15rem !important;
    }

    .dropdown-item,
    .nav-link {
      font-size: 1rem;
    }

    .dropdown-item img,
    .dropdown-item svg,
    .nav-link img,
    .nav-link svg {
      height: 19px;
      max-width: 19px;
    }

    .crm-dropdown-caret {
      width: 14px;
      height: 14px;
    }

    .crm-navbar-chat-desktop,
    .crm-navbar-profile-nav {
      flex: 0 0 auto;
    }

    .crm-navbar-chat-desktop {
      margin-right: 0.35rem !important;
    }

    .btn-chat-navbar {
      gap: 5px;
      padding: 6px 12px;
      font-size: 0.84rem;
    }

    .btn-chat-navbar svg {
      width: 19px;
      height: 19px;
    }

    .profile-circle {
      width: 35px;
      height: 35px;
    }

    .profile-circle img {
      width: 100%;
      height: 100%;
      max-width: none;
      object-fit: cover;
    }

    .crm-dropdown-profile .rounded-circle {
      width: 35px !important;
      height: 35px !important;
    }
  }

  @media (min-width: 992px) and (max-width: 1439.98px) {
    &.navbar {
      padding-left: 0.4rem;
      padding-right: 0.4rem;
    }

    .navbar-brand {
      margin-right: 0.35rem;
    }

    .navbar-brand .crm-navbar-logo {
      width: 88px;
      height: 26px;
    }

    .dropdown-item,
    .nav-link {
      font-size: 0.84rem;
    }

    .crm-navbar-primary .dropdown-toggle,
    .crm-navbar-primary > .nav-link,
    .crm-navbar-primary .nav-item > .nav-link {
      padding-left: 0.18rem;
      padding-right: 0.18rem;
    }

    .crm-navbar-primary .mr-2 {
      margin-right: 0.18rem !important;
    }

    .dropdown-item img,
    .dropdown-item svg,
    .nav-link img,
    .nav-link svg {
      height: 16px;
      max-width: 16px;
    }

    .btn-chat-navbar {
      padding: 5px 9px;
      font-size: 0.8rem;
    }

    .profile-circle,
    .crm-dropdown-profile .rounded-circle {
      width: 33px !important;
      height: 33px !important;
    }

    .profile-circle img {
      width: 100%;
      height: 100%;
      max-width: none;
      object-fit: cover;
    }
  }

  @media (min-width: 1600px) {
    &.navbar {
      padding: 0.62rem 0.85rem;
    }

    .navbar-brand {
      margin-right: 0.65rem;
    }

    .navbar-brand .crm-navbar-logo {
      width: 106px;
      height: 34px;
    }

    .crm-navbar-primary .dropdown-toggle,
    .crm-navbar-primary > .nav-link,
    .crm-navbar-primary .nav-item > .nav-link {
      padding-left: 0.34rem;
      padding-right: 0.34rem;
    }

    .btn-chat-navbar {
      padding: 7px 14px;
    }

    .profile-circle,
    .crm-dropdown-profile .rounded-circle {
      width: 38px !important;
      height: 38px !important;
    }
  }
`;

export const BtnRanking = styled(Link)`
  && {
    background: rgba(252, 176, 69, 1);
    background: linear-gradient(
      80deg,
      rgba(253, 130, 50, 1) 0%,
      rgba(252, 176, 69, 1) 100%
    );

    line-height: 1;
  }
`;
